(function(){
  function r(){
    document.querySelectorAll("a,span,div,li").forEach(e=>{
      const t=e.textContent.trim();
      if(t==="catalog") e.textContent="catalogue";
      else if(t==="Catalog") e.textContent="Catalogue";
      else if(t==="CATALOG") e.textContent="CATALOGUE";
    });
  }
  r();
  new MutationObserver(r).observe(document.body,{childList:true,subtree:true});
})();








document.addEventListener('DOMContentLoaded', () => {
  runVariantAI();
});

document.addEventListener('change', (e) => {
  if (e.target.closest('variant-picker')) {
    setTimeout(runVariantAI, 50);
  }
});

function runVariantAI() {
  const selected = document.querySelector('variant-picker select option[selected], variant-picker input:checked');
  const variantId = selected?.dataset?.variantId || null;

  const elements = document.querySelectorAll('.varaint_url');

  if (!elements.length) return;

  let hasMultiple = elements.length > 1;
  let matched = false;

  elements.forEach((el) => {
    el.classList.remove('active');

    if (variantId && el.dataset.vid === variantId) {
      el.classList.add('active');
      matched = true;
    }
  });

  if (!hasMultiple) {
    elements.forEach((el) => el.classList.add('active'));
    return;
  }

  if (!matched) {
    elements.forEach((el) => el.classList.remove('active'));
  }
}